type StepIndicatorProps = {
  currentStep: number;
  totalSteps: number;
  label?: string;
};

export const StepIndicator = ({
  currentStep,
  totalSteps,
  label,
}: StepIndicatorProps) => {
  if (currentStep === -1) {
    return null;
  }

  return (
    <div className="t-text-subtext-sm t-text-neutral-40 t-mb-4">
      Step {currentStep} of {totalSteps}
      {label && `: ${label}`}
    </div>
  );
};
